module.exports = __webpack_public_path__ + "static/img/a116.2f7fd69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a116.jpg
// module id = 8D+D
// module chunks = 0